import { Box } from '@mui/material'
import { getIn, useFormikContext } from 'formik'
import React from 'react'

import { IsItem } from '../../interfaces/IsItem'
import TextField from '../TextField'
import ErrorMessage from './ErrorMessage'

interface Props {
  name: string
  items: IsItem[]
  [otherProps: string]: any
}

const FormTextField: React.FC<Props> = ({ name, items, ...otherProps }) => {
  const { handleChange, setFieldTouched, errors, touched, values } = useFormikContext()

  return (
    <Box
      sx={{
        mb: 2.5,
      }}
    >
      <TextField
        fullWidth
        items={items}
        onBlur={() => setFieldTouched(name)}
        onChange={handleChange(name)}
        {...otherProps}
        value={getIn(values, name)}
      />
      <ErrorMessage error={getIn(errors, name)} visible={getIn(touched, name)} />
    </Box>
  )
}

export default FormTextField
